import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getPastDueClients(filters, showLoader) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v2/past-due-clients/',
      method: HttpMethod.GET
    };
    const params = { ...filters };
    if (params.minApprovedAmount != null) {
      params.minApprovedAmount *= 1000000;
    }
    if (params.maxApprovedAmount != null) {
      params.maxApprovedAmount *= 1000000;
    }
    if (params.minTotalApprovedAmount != null) {
      params.minTotalApprovedAmount *= 1000000;
    }

    params.hasValueAdjustment = +params.hasValueAdjustment;

    try {
      const res = await processRequest(ep, { params }, showLoader);
      const { items, total, loanBalance } = processSuccessResponse(res);

      return { items, total, callResults: null, loanBalance };
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getDueContractsByClient(id, fromDate, toDate) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${id}/due-contracts/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          pageSize: -1,
          fromDate,
          toDate
        }
      });

      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClientDetail(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/finflux-${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async createPaymentReminderResult(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${id}/payment-reminder-results/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const result = processSuccessResponse(res);

      return result;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getPaymentReminderResultsListByClient(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${id}/payment-reminder-results/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: { pageSize: 20 }
      });
      const result = processSuccessResponse(res);

      return result;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getContractNotes(contractId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/notes/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          pageSize: -1
        }
      });

      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addContractNotes(contractId, content) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/notes/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {
        data: {
          content
        }
      });

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addMultipleContractNotes(contractIds, content) {
    const promises = [];
    contractIds.forEach((id) => {
      promises.push(new Promise((resolve) => {
        const create = async () => {
          try {
            const data = await this.addContractNotes(id, content);
            resolve(data);
          } catch(e) {
            resolve(null);
          }
        };

        create();
      }));
    });

    const results = await Promise.all(promises);
    return results;
  },

  async getSummaryInfo(params) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: '/v2/past-due-clients/summary/',
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, { params });
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
